/* @flow */
import * as React from 'react';
import { inject, observer } from 'mobx-react';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Button from '@material-ui/core/Button';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import { translate } from 'react-i18next';
import Moment from 'react-moment';

import type { TranslatorProps } from 'react-i18next';

import type TypeActionDrawerStore from 'stores/ActionDrawerStore';

import styles from '../../../../ActionDrawer.module.scss';

type TypeProps = {
  t: TranslatorProps,
  actionDrawerStore: TypeActionDrawerStore,
  response: Object,
};

@translate()
@inject('actionDrawerStore')
@observer
export default class ScheduleCalMultiSuccess extends React.Component<*> {
  render(): React.Node {
    const { t, actionDrawerStore, response }: TypeProps = this.props;

    return (
      <React.Fragment>
        <div className={styles['action-drawer-content']}>
          <div className={styles['success-details']}>
            <h3>{t('general:calibrations.requests_sent')}</h3>
            <p>{t('general:contracts.messages.schedule_calibration')}</p>
            <p>{t('general:contracts.messages.schedule_calibration_receipt')}</p>
            <ul>
              <li>
                <b>{t('general:assets.labels.to_be_calibrated')}:</b>
              </li>
              {response.map((asset, index) => {
                return <li key={asset.asset_number}>{`${asset.model} - ${asset.asset_number}`}</li>;
              })}
            </ul>
            <ul>
              <li>
                <b>{t('general:labels.available_for_collection')}:</b>
              </li>
              <li>
                <Moment date={response[0].collection_date} format="MMMM DD, YYYY" />
              </li>
            </ul>
          </div>
        </div>
        <div className={styles['action-drawer-actions']}>
          <Button
            variant="contained"
            color="primary"
            onClick={() => actionDrawerStore.closeActionDrawer()}
          >
            {t('general:actions.close')}
          </Button>
        </div>
      </React.Fragment>
    );
  }
}
